// src/pages/AdminExceptions.js
import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import { ref, onValue, update } from "firebase/database";

function b64(s) { return btoa((s || "").toLowerCase()); }

export default function AdminExceptions() {
  const [roll, setRoll] = useState("");
  const [email, setEmail] = useState("");
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    const off = onValue(ref(db, "exceptionsByRoll"), (snap) => {
      const v = snap.val() || {};
      const list = Object.entries(v).map(([r, o]) => ({ roll: r, ...o }));
      setRows(list.sort((a,b) => (b.ts||0) - (a.ts||0)));
    });
    return () => off();
  }, []);

  async function addOrUpdate() {
    const R = roll.trim().toUpperCase();
    const E = email.trim().toLowerCase();
    if (!R) return alert("Enter roll number");
    if (!E || !E.includes("@")) return alert("Enter valid email");

    const now = Date.now();
    const up = {};
    // roll -> email (for preferred email lookup)
    up[`exceptionsByRoll/${R}`] = { e: E, ts: now };
    // email -> roll (for login auto-roll resolution)
    up[`exceptionsByEmail/${b64(E)}`] = R;
    // allow this email to Google-login as participant
    up[`authExceptions/${b64(E)}`] = true;
    await update(ref(db), up);
    setRoll(""); setEmail("");
  }

  async function del(r, e) {
    if (!window.confirm(`Remove exception for ${r}?`)) return;
    const up = {};
    up[`exceptionsByRoll/${r}`] = null;
    if (e) {
      up[`exceptionsByEmail/${b64(e)}`] = null;
      up[`authExceptions/${b64(e)}`] = null;
    }
    await update(ref(db), up);
  }

  const filtered = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return rows;
    return rows.filter(x =>
      x.roll.toLowerCase().includes(t) || (x.e || "").toLowerCase().includes(t)
    );
  }, [rows, q]);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Admin — Participant Email Exceptions</h1>
      <p className="text-sm text-gray-600">
        Map a roll number to an alternate email (non-<code>vnrvjiet.in</code>). The mapping auto-allows Google login and auto-loads participant details.
      </p>

      <div className="bg-white rounded-2xl shadow p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <input className="p-3 border rounded-xl" placeholder="Roll Number (e.g., 22XX1234)"
                 value={roll} onChange={e=>setRoll(e.target.value)} />
          <input className="p-3 border rounded-xl" placeholder="Alternate Email"
                 value={email} onChange={e=>setEmail(e.target.value)} />
          <button onClick={addOrUpdate}
                  className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Save Exception</button>
        </div>
        <div className="flex">
          <input className="ml-auto p-3 border rounded-xl" placeholder="Search roll/email"
                 value={q} onChange={e=>setQ(e.target.value)} />
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="py-2 pr-4">Roll</th>
              <th className="py-2 pr-4">Alternate Email</th>
              <th className="py-2 pr-4">Updated</th>
              <th className="py-2 pr-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(r => (
              <tr key={r.roll} className="border-b hover:bg-gray-50">
                <td className="py-2 pr-4 font-mono">{r.roll}</td>
                <td className="py-2 pr-4">{r.e}</td>
                <td className="py-2 pr-4 text-gray-500">{r.ts ? new Date(r.ts).toLocaleString() : "-"}</td>
                <td className="py-2 pr-4">
                  <button onClick={()=>del(r.roll, r.e)}
                          className="px-3 py-1 rounded-lg border hover:bg-red-50 text-red-600">Delete</button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="4" className="py-6 text-gray-500">No exceptions.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
